module.exports = __webpack_public_path__ + "img/selfie-with-frankenstein.c0cd0736.jpg";